export const formatPounds = function (
  amount: number,
  denomination: "pennies" | "pounds" = "pennies",
  omitDecimals = false,
  options?: Intl.NumberFormatOptions,
) {
  if (denomination === "pennies") {
    amount = amount / 100;
  }

  return amount.toLocaleString("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: omitDecimals ? 0 : 2,
    minimumFractionDigits: omitDecimals ? 0 : 2,
    ...options,
  });
};

export const formatPoundsOmitTrailingZeros = (amount: number, denomination: "pennies" | "pounds" = "pennies") =>
  formatPounds(amount, denomination, false, {minimumFractionDigits: 0});

export const penceFromPounds = (pounds: number) => Math.round(pounds * 100);
